export default {
  solutions: {
    breadcrumbHome: 'Home',
    breadcrumbCurrent: 'Solutions',
    hero: {
      eyebrow: 'Solutions',
      title: 'The right solution for every property',
      lead: 'Whether a private home, retail space or warehouse – together we find the optimal camera system for your requirements.',
    },
    grid: {
      eyebrow: 'Property solutions at a glance',
      title: 'Six areas – one promise: real security',
      lead: 'Each card leads to a dedicated overview with typical surveillance points and suitable technical solutions.',
    },
    tag: { privat: 'Private', gewerbe: 'Commercial', innen: 'Indoor', außen: 'Outdoor', neu: 'New', erweiterung: 'Expansion' },
    more: 'Learn more',
    cta: {
      title: 'Not sure which solution fits?',
      lead: 'We analyse your property together and recommend the right combination of cameras, recording and accessories.',
      primary: 'Get advice without obligation',
      secondary: 'Start the Camera Planner',
    },
  },
};